import { Listeners, onSortGoTo } from './utils.js';

export class CosPaginatedGrid extends HTMLElement {
  // constructor() {
  //   super();

  //   console.log('CosPaginatedGrid:constructor:settings', this.settings);
  // }

  connectedCallback() { 
    this.settings = JSON.parse(this.getAttribute('data-settings')) || {};  
    this.gridList = this.querySelector('[grid-list]');
    
    if (!this.gridList) return; 

    this.listeners = new Listeners();
    this.loading = false;

    const storagePathname = window.location.pathname.replace(/\//g, '_');
    this.initialSearch = window.location.search;

    this.STORAGE_KEY_LIST = `grid_list_${storagePathname}`;
    this.STORAGE_KEY_PAGINATE = `grid_paginate_${storagePathname}`;
    // this.STORAGE_KEY_SCROLLTOP = `grid_scrolltop_${storagePathname}`;
    this.STORAGE_KEY_SEARCH = `grid_search_${storagePathname}`;

    this.replaceRegex = /keen-loaded|lazy-loaded|quick-add-active|show-options|show-colors|lazy-waiting|<div class="btn slick-arrow slick-prev"><\/div><div class="btn slick-arrow slick-next"><\/div>|<wishlist-button-collection[\d\D]*?wishlist-button-collection>|" style="opacity: 0; z-index: 0;|" style="opacity: 1; z-index: 1;| wk-skip=""| wk-skip/g;

    this.lastState();
    this.initLoadMore();

    this.listeners.add(window, 'pagehide', (event) => {
      // if (event.persisted) return;
      this.beforeUnload();
    });
  }

  disconnectedCallback() {
    this.listeners.removeAll();

    if (this.observer) {
      this.observer.disconnect();
    }
  }

  initLoadMore() {
    this.initialPaginate = JSON.parse(this.gridList.getAttribute('data-paginate')) || {};
    this.paginate = this.paginate || this.initialPaginate;

    this.loadMoreBtn = this.querySelector('[load-more]');
    if (!this.loadMoreBtn) return;
    
    this.initialLoadMoreText = this.loadMoreBtn.innerHTML;

    this.loadMoreBtn.addEventListener('click', () => {
      this.loadMore();
    });
      
    if (this.settings.loadType !== 'scroll') return;
    const marginSize = this.paginate.page_size > 24 ? 200 : 100;
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        // Unsubscribe right away
        // observer.unobserve(entry.target);
        // do something
        this.loadMore();
      }
    }, {
      rootMargin: `0px 0px ${marginSize}% 0px`,
      threshold: [0.0, 0.5, 1.0]
    });
    this.observer.observe(this.loadMoreBtn);
  }

  handleLoadMore() {
    this.loadMoreBtn = this.loadMoreBtn || this.querySelector('[load-more]');
    if (!this.loadMoreBtn) return;
    (this.paginate.next) ? this.loadMoreBtn.classList.remove('hidden') : this.loadMoreBtn.classList.add('hidden');
  }

  async getPage(url) {    
    return await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${this.settings.sectionId}`).then(response => response.text());
  }

  async loadMore() {
    if (this.loading || !this.paginate.next) return;
    this.updateLoading(true);

    const wrapper = document.createElement('div');      
    wrapper.innerHTML = await this.getPage(this.paginate.next.url);

    this.switchGridList(wrapper, 'beforeend');

    this.handleLoadMore();
    this.updateLoading(false);
  }

  switchGridList(wrapper, method = 'replace') {
    const gridList = wrapper.querySelector('[grid-list]');
    if (!gridList) return;

    this.paginate = JSON.parse(gridList.getAttribute('data-paginate')) || {};
    
    if (method === 'replace') {
      this.gridList.innerHTML = gridList.innerHTML;
    } else {
      const bannerstoRemove = this.gridList.querySelectorAll('[banner]');
      this.gridList.insertAdjacentHTML('beforeend', gridList.innerHTML);
      bannerstoRemove.forEach(banner => banner.remove());
    }
  }

  updateLoading(loading) {
    this.loading = loading;

    if (!this.loadMoreBtn) return;
    this.loadMoreBtn.disabled = loading;

    if (loading) {
      this.loadMoreBtn.classList.add('loading');
      this.loadMoreBtn.innerHTML = `<span>${window.custom.icons.spinner}</span>`;
    } else {
      this.loadMoreBtn.classList.remove('loading');
      this.loadMoreBtn.innerHTML = this.initialLoadMoreText;
    }
  }

  beforeUnload() {
    try {
      sessionStorage.setItem(this.STORAGE_KEY_LIST, this.gridList.innerHTML); // .replace(this.replaceRegex, '')); // this.gridList.innerHTML.replace(this.replaceRegex, ''));
      sessionStorage.setItem(this.STORAGE_KEY_PAGINATE, JSON.stringify(this.paginate));
      // sessionStorage.setItem(this.STORAGE_KEY_SCROLLTOP, window.scrollY);
      sessionStorage.setItem(this.STORAGE_KEY_SEARCH, window.location.search);
    } catch (e) {
      // SecurityError can occur in sandbox/iframe contexts
    }
  }

  lastState() {
    if (window.Shopify.designMode) return;
    
    try {
      const navType = performance && performance.getEntriesByType('navigation').map(nav => nav.type);
      if (!navType.includes('back_forward')) return this.resetStorage(navType.includes('reload'));
      
      const lastGridList = sessionStorage.getItem(this.STORAGE_KEY_LIST);
      const lastPaginate = JSON.parse(sessionStorage.getItem(this.STORAGE_KEY_PAGINATE));
      // const lastScrollTop = sessionStorage.getItem(this.STORAGE_KEY_SCROLLTOP) || 0;
      const lastSearch = sessionStorage.getItem(this.STORAGE_KEY_SEARCH);

      if (!lastGridList || !lastPaginate) return this.resetStorage();
      if (lastSearch !== this.initialSearch) return this.resetStorage();
      
      // if (!stripHtml(lastGridList).startsWith(stripHtml(this.gridList))) return this.resetStorage(true);

      this.gridList.innerHTML = lastGridList.replace(this.replaceRegex, '');
      // if (window.scrollY !== lastScrollTop) window.scrollTo(0, lastScrollTop);
      this.paginate = lastPaginate;

      this.handleLoadMore();
    } catch (e) {
      // SecurityError can occur in sandbox/iframe contexts
      this.resetStorage();
    }
  }

  resetStorage(goTo = false) {
    try {
      sessionStorage.removeItem(this.STORAGE_KEY_LIST);
      sessionStorage.removeItem(this.STORAGE_KEY_PAGINATE);
      // sessionStorage.removeItem(this.STORAGE_KEY_SCROLLTOP);
      sessionStorage.removeItem(this.STORAGE_KEY_SEARCH);
    } catch (e) {
      // SecurityError can occur in sandbox/iframe contexts
    }
    this.paginate = this.initialPaginate;
    if (goTo) onSortGoTo();
  }
}

customElements.define('cos-paginated-grid', CosPaginatedGrid);  